import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Image } from '../../../ui';
import DotLoader from '../../dotLoader';
import TypographyEnhanced from '../../typography';

const useStyles = makeStyles(() => ({
  button: {
    height: '40px',
    width: '215px',
    backgroundColor: '#4285F4',
    border: '1px solid #4285F4',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  iconContainer: {
    height: '38px',
    width: '38px',
    backgroundColor: '#fff',
    borderRadius: '1px'
  },
  labelContainer: {
    height: '16px',
    padding: '12px'
  },
  label: {
    color: '#fff',
    lineHeight: '1'
  },
  light: {},
  dark: {}
}));

/**
 * @description:
 * Button for Google log in
 *
 * @typedef {import('@mui/material').ButtonProps} ButtonProps Props for `Button` from '@mui/material` library
 * @param {{ loading: Boolean } & ButtonProps} props loading state for Spinner
 * @returns {React.FC<ButtonProps>}
 */
const GoogleSignIn = ({ loading, onClick, disabled, ...props }) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Box className={classes.button} onClick={onClick} disabled={disabled} {...props}>
        <Grid container>
          <Grid item container justifyContent='center' className={classes.iconContainer}>
            <Image src='/assets/img/logo_google.svg' alt='Google signin' />
          </Grid>
          <Grid item className={classes.labelContainer}>
            <TypographyEnhanced id={'Sign in with Google'} className={classes.label} />
          </Grid>
        </Grid>
      </Box>
      {loading && <DotLoader />}
    </Fragment>
  );
};

GoogleSignIn.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

export default GoogleSignIn;
